module.exports = __webpack_public_path__ + "img/fist.8731fc4d.svg";